import {
  Component,
  forwardRef,
  Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';

import {
  BlockUI,
  NgBlockUI
} from 'ng-block-ui';

import { HaynesProAdjustmentModel } from '../typings/haynes-pro.adjustment';
import { HaynesProService }         from '../haynes-pro.service';
import { HaynesProSubGroupModel }   from '../typings/haynes-pro.sub-group';
import { MessagesService }          from '../../messages/messages.service';
import { VehicleModel }             from '../../vehicles/models/vehicle';

@Component({
  selector   : 'wor-haynes-pro-diagnostic-tool-adjustments',
  template: require('./haynes-pro.diagnostic-tool.adjustments.component.html')
})
export class HaynesProDiagnosticToolAdjustmentsComponent implements OnChanges, OnInit {

  @BlockUI('haynesProAdjustmentsBlock') block : NgBlockUI;

  @Input() isActive : boolean;
  @Input() subGroups: Array<HaynesProSubGroupModel>;
  @Input() vehicle  : VehicleModel;

  adjustments : Array<HaynesProAdjustmentModel> = [];
  subGroup    : HaynesProSubGroupModel;

  constructor (
    @Inject(forwardRef(() => HaynesProService)) private haynesProService : HaynesProService,
    private messagesService  : MessagesService
  ) {}

  ngOnChanges ( changes : SimpleChanges ) : void {
    if ( changes.isActive && !changes.isActive.isFirstChange() && changes.isActive.currentValue ) {
      const subGroup = this.subGroup
        ? this.subGroup
        : this.subGroups[0];

      subGroup.selected = true;
    }
  }

  ngOnInit () : void {
    if (this.isActive) {

      this.subGroups[0].selected = true;

      };

    }

  handleSubGroupSelection ( subGroup : HaynesProSubGroupModel ) : void {
    this.block.start();

    this.adjustments = [];
    this.subGroup    = subGroup;

    this.haynesProService.getAdjustments(this.vehicle, subGroup.name)
    .then(( adjustments : Array<HaynesProAdjustmentModel> ) => {
      this.adjustments = adjustments;

      if( !this.isActive ) {


        this.haynesProService.updateSubscriptionStatus(true);


      }
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }

}